<template>
  <div
    :class="`activity-task-status-icon activity-task-status-icon--theme-${type}`"
    :aria-label="statusText"
    :title="statusText"
  >
    <CheckmarkIcon
      v-if="type === 'completed'"
      class="activity-task-status-icon__image"
    />
    <ExitIcon
      v-if="type === 'rejected'"
      class="activity-task-status-icon__image"
    />
  </div>
</template>

<script lang="ts" setup>
import CheckmarkIcon from '@/components/icon_components/CheckmarkIcon.vue'
import ExitIcon from '@/components/icon_components/ExitIcon.vue'
import { useI18n } from '@/hooks/useI18N'
import { computed } from 'vue'

const i18n = useI18n()

const props = defineProps<{
  type: 'completed' | 'rejected' | 'not-completed'
}>()

const statusText = computed(() => {
  switch (props.type) {
    case 'completed':
      return i18n.t('approvals.COMPLETED')
    case 'rejected':
      return i18n.t('approvals.REJECTED')
    default:
      return i18n.t('approvals.NOT_COMPLETED')
  }
})
</script>

<style scoped lang="scss">
.activity-task-status-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: $spacing-s;
  height: $spacing-s;
  border-radius: 50%;
  border: 1px solid transparent;

  &--theme-completed {
    background-color: $color-green-05;
    color: $color-green-60;
  }

  &--theme-rejected {
    background-color: $color-red-05;
    color: $color-red-60;
  }

  &--theme-not-completed {
    background-color: $color-paper;
    border: 1px dashed $color-steel;
  }

  &__image {
    width: $spacing-3xs;
    height: $spacing-3xs;
  }
}
</style>
